function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.496 6a1.5 1.5 0 011.5 1.5l-.001.748c.103 1.837-1.312 2.753-3.935 2.753C1.446 11 0 10.097 0 8.275V7.5A1.5 1.5 0 011.5 6h4.996zm4 0a1.5 1.5 0 011.5 1.5v.527c.09 1.647-1.16 2.473-3.444 2.473-.31 0-.602-.015-.874-.045.536-.496.823-1.169.822-2.018l-.006-.217.002-.72c0-.598-.262-1.134-.678-1.5h2.678zM4 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm5 1a2 2 0 110 4 2 2 0 010-4z",
  fill: "#8F90A6"
});

function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGroup;